import NativeModulesProxy from '../NativeModulesProxy';
export default NativeModulesProxy.ExpoModulesCoreErrorManager;
//# sourceMappingURL=NativeErrorManager.js.map